import Tasks from 'APP/Tasks';
import Entities from 'STORE';
import { ArticlePayload } from 'STORE/Messages/Message/Payload/ArticlePayload/ArticlePayload';

export async function updateScheduledArticle(
  groupId: string,
  messageId: string,
  payload: ArticlePayload
): Promise<void> {
  const scheduledGroup = Entities.GroupsStore.getGroupById(groupId);
  if (!scheduledGroup) {
    return;
  }

  const message = scheduledGroup.messagesStore.getMessageById(messageId);
  if (!message) {
    return;
  }

  const canEdit = Tasks.messaging.canSendMessage({
    groupId,
    isCheckSlowMode: false,
    isNewMessage: false,
    payload,
  });

  if (!canEdit.result) {
    canEdit.error && Tasks.app.showToast(canEdit.error);
    return;
  }

  message.payload = payload;

  await Tasks.messaging.editScheduledMessage({
    message,
    date: new Date(message.serverTime),
  });
}
